import { useCallback } from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { setItem } from '../../shared/services/storage/storage';
import { STORAGE_KEY, imgsPath } from '../../shared/config';

const Language = () => {
  const { t } = useTranslation();
  const changeLanguage = useCallback((newLng: string) => {
    if (i18n.language !== newLng) {
      // eslint-disable-next-line import/no-named-as-default-member
      i18n.changeLanguage(newLng);
      setItem(STORAGE_KEY.LANGUAGE, newLng);
    }
  }, []);
  return (
    <div className="language">
      {i18n.language === 'en' && (
        <button onClick={() => changeLanguage('it')}>
          <img
            className="w-8"
            src={`${imgsPath}flags/it.svg`}
            alt={t('change language to italian')}
            title={t('change language to italian')}
          />
        </button>
      )}
      {i18n.language === 'it' && (
        <button onClick={() => changeLanguage('en')}>
          <img
            className="w-8"
            src={`${imgsPath}flags/gb.svg`}
            alt={t('change language to english')}
            title={t('change language to english')}
          />
        </button>
      )}
    </div>
  );
};

export default Language;
